"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rfidTagDumpTruckAction = exports.rfidTagDumpTruckReducer = exports.rfidTagDumpTruckTypes = void 0;
const rfid_tag_dumptruck_types_1 = require("./rfid-tag-dumptruck.types");
Object.defineProperty(exports, "rfidTagDumpTruckTypes", { enumerable: true, get: function () { return rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes; } });
const rfid_tag_dumptruck_component_1 = __importDefault(require("./sub-component/rfid-tag-dumptruck.component"));
const rfid_tag_dumptruck_reducer_1 = __importDefault(require("./rfid-tag-dumptruck.reducer"));
exports.rfidTagDumpTruckReducer = rfid_tag_dumptruck_reducer_1.default;
const rfid_tag_dumptruck_action_1 = __importDefault(require("./rfid-tag-dumptruck.action"));
exports.rfidTagDumpTruckAction = rfid_tag_dumptruck_action_1.default;
exports.default = rfid_tag_dumptruck_component_1.default;
